// 动漫类型
export const animeTypes = [
  {
    label: "动漫",
    value: "video",
    number: 1,
    kinds: [
      { label: "哩番", value: 1 },
      { label: "3D", value: 2 },
      { label: "同人动画", value: 3 },
      { label: "剧场", value: 8 },
    ],
  },
  {
    label: "漫画",
    value: "image",
    number: 2,
    kinds: [
      { label: "单行本", value: 4 },
      { label: "连载漫画", value: 5 },
      { label: "韩漫", value: 6 },
    ],
  },
  {
    label: "小说",
    value: "text",
    number: 3,
    kinds: [
      { label: "有声小说", value: 7 },
      { label: "文字小说", value: 8 },
    ],
  },
];

// 动漫种类
export const animeKinds = [];
animeTypes.forEach((v) => {
  animeKinds.push(...v.kinds);
});

// 动漫标签类型
export const animeLabelTypes = [
  { label: "动漫", value: 1 },
  { label: "漫画", value: 2 },
  { label: "文本小说", value: 3 },
  { label: "有声小说", value: 4 },
  { label: "剧场", value: 5 },
];

export const animeUpdateStatus = [
  {
    label: "更新中",
    value: 1,
  },
  {
    label: "已完结",
    value: 2,
  },
];
